import { makeStyles } from '@material-ui/core/styles';
import { CORES } from '../../theme';

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  drawer: {
    [theme.breakpoints.up('sm')]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    backgroundColor: CORES.verdeEscuro,
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  tituloPagina: {
    flexGrow: 1,
    fontWeight: 600,
  },
  usuarioTopo: {
    fontSize: 14,
    opacity: 0.9,
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
    display: 'flex',
    flexDirection: 'column',
  },
  drawerConteudo: {
    flex: 1,
    overflowY: 'auto',
  },
  logo: {
    textAlign: 'center',
    padding: '8px 16px',
  },
  itemMenu: {
    borderRadius: 8,
    margin: '2px 8px',
    width: 'auto',
    color: CORES.texto,
    '&:hover': {
      backgroundColor: CORES.verdeClaro,
    },
  },
  itemMenuAtivo: {
    backgroundColor: CORES.verdeClaro,
    color: CORES.verdeEscuro,
    fontWeight: 600,
    '& $iconeMenu': {
      color: CORES.verde,
    },
  },
  iconeMenu: {
    minWidth: 40,
    color: CORES.textoSuave,
  },
  rodapeMenu: {
    borderTop: `1px solid ${CORES.borda}`,
    padding: '12px 16px',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  nomeUsuario: {
    flex: 1,
    minWidth: 0,
    fontSize: 14,
    fontWeight: 600,
    color: CORES.texto,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    backgroundColor: CORES.fundo,
    minHeight: '100vh',
  },
}));

export default useStyles;
